<template>
    <div id="certAdd" class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/certiFicate')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSub('ruleForm')"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
            <div class="edit-from">
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form-item label="证书名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入证书名称【1-50】" clearable></el-input>
        </el-form-item>
          <el-form-item label="证书等级：" prop="certLevel">
                    <el-input v-model="form.certLevel" placeholder="请输入证书等级【1-10】" clearable></el-input>
        </el-form-item>
         <el-form-item label="证书分类：" prop="classifyId">
                 <el-select
                        v-model="form.classifyId"
                        clearable
                        placeholder="请选择证书分类"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
         </el-form-item>
           <el-form-item label="证书专业：" prop="certMajor">
                    <el-input v-model="form.certMajor" placeholder="请输入证书专业【1-10】" clearable></el-input>
        </el-form-item>
               <el-form-item label="排序：" >
                    <el-input v-model="form.sort" placeholder="请输入排序" clearable></el-input>
        </el-form-item>
          <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  证书信息
            </div>
        </div>
          <el-form-item label="证书标题：" prop="title">
             <el-input v-model="form.title" placeholder="请输入标题【1-12】" clearable></el-input>
        </el-form-item>
        <el-form-item label="证书编号：" prop="certNoRule">
             <el-radio v-model="form.certNoRule" label="0">系统随机</el-radio>
            <el-radio v-model="form.certNoRule" label="1">自定义格式</el-radio>
             <el-input v-model="form.prefixCertNo" placeholder="输入前3位前缀，后续根据数字" clearable v-if="form.certNoRule == '1'" style="width:40%"></el-input>
          </el-form-item>
         <el-form-item label="证书文案：" prop="content">
            <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="form.content"
            maxlength="500"
            show-word-limit
            rows="5"
            >
            </el-input>
        </el-form-item>
          <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  上传签章
            </div>
        </div>
            <el-form-item label="发证机构签章：" prop="institutionSignet">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">140*140</span></div>
                    <img :src="form.institutionSignet" class="avatar" v-if="form.institutionSignet">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.institutionSignet" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(1)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(1)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.institutionSignet" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                  <!-- <el-form-item label="发证机构负责人签章：" prop="principalSignet">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean1"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">130*50</span></div>
                    <img :src="form.principalSignet" class="avatar1" v-if="form.principalSignet">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span v-if="form.principalSignet" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(2)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(2)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible1" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.principalSignet" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item> -->
         </el-form>
            </div>
    </div>
</template>
<script>
import {getAllCertClassify,editCertificate,deletCertificate} from "@/api/index/index"  //证书分类、新增证书、查询证书详情
import debounce from '../../../../utils/debounce.js' //防抖
export default {
    data () {
        return {
            uploadBoolean:false,
            uploadBoolean1:false,
            oploadDialogVisible:false,
            oploadDialogVisible1:false,
            headers:{},
            itemList:[],
            loading:false,
            form:{
                name:'',
                certLevel:'',
                classifyId:'',
                sort:'',
                title:'',
                content:'',
                certNoRule:'',
                institutionSignet:'',
                principalSignet:'',
                prefixCertNo:'',
            },
            rules:{
             name: [{ required: true, message: '请输入证书名称', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
              certLevel: [{ required: true, message: '请输入证书等级', trigger: 'blur' },
             { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
             ],
              classifyId: [{ required: true, message: '请选择证书分类', trigger: 'change' }],
               certMajor: [{ required: true, message: '请输入证书专业', trigger: 'blur' },
             { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
             ],
              title: [{ required: true, message: '请输入证书标题', trigger: 'blur' },
             { min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' }
             ],
            content: [{ required: true, message: '请输入证书文案', trigger: 'blur' }],
            certNoRule: [{ required: true, message: '请选择证书编号', trigger: 'change' }],
            institutionSignet:[{ required: true, message: '请上传发证机构签章', trigger: 'blur' }],
            }
        }
    },
    created () {
        this.getCourseClass()
        this.getCertDetail()
          let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 证书详情
        getCertDetail(){
             deletCertificate({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                name:res.data.name,
                classifyId:res.data.classifyId,
                certMajor:res.data.certMajor,
                certLevel:res.data.certLevel,
                sort:res.data.sort,
                title:res.data.title,
                content:res.data.content,
                certNoRule:res.data.certNoRule,
                institutionSignet:res.data.institutionSignet,
                principalSignet:res.data.principalSignet,
                prefixCertNo:res.data.prefixCertNo,
                }
            })
            .catch(err =>{})
        },
         // 获取证书分类
          getCourseClass(){
            this.itemList = []
             getAllCertClassify({
                name:''
             })
            .then(res => {
                
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 保存
        openSub(formName){
            let params = {}
            let method = "post"
            if(!this.$route.query.id) params = {...this.form},method = "post";
            if(this.$route.query.id) params = {...this.form,id:this.$route.query.id}, method = "put";
            if(this.form.certNoRule == '1' && !this.form.prefixCertNo)  return this.$util.Notifi('请填写证书编号前缀','error','fa-exclamation-circle');
             this.$refs[formName].validate((valid) => {  
                     if(valid){
                         //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                     }
             })

        },
               commentBness(params,method){
               this.loading = true
                editCertificate(params,method)
                    .then(res => {
                        if(res.code == 0){
                        this.loading = false
                        if(!this.$route.query.id) this.$message.success('新增成功');
                            setTimeout(() => {
                        this.$router.push({
                        name:'certiFicate',
                        query:{
                        }
                        })
                            }, 100);
                        }else{
                            this.loading = false
                        this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.loading = false
                    })
        },
             handleAvatarSuccess(res, file) {
        this.form.institutionSignet = res.data.url
        if(this.form.institutionSignet){
        this.uploadBoolean = true
         }
      },
            handleAvatarSuccess1(res, file) {
        this.form.principalSignet = res.data.url
        if(this.form.principalSignet){
        this.uploadBoolean1 = true
         }
      },
       // 图片放大
         oploadImgPre(type){
                if(type == 1) this.oploadDialogVisible = true
                if(type == 2) this.oploadDialogVisible1 = true
            },
          oploadImgDel(type){
              if(type == 1){
                this.form.institutionSignet = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
              }else if(type == 2){
                 this.form.principalSignet = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean1 = false
                },1000)
              }
            },
    },
}
</script>
<style lang="scss" scoped>
   .edit-from{
         margin-bottom: 44px;
         .public-tit{
            width: 100%;
            margin-bottom: 20px;
         }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }
   .avatar1 {
    width: 130px;
    height: 50px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>